// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"notificationStats_wrapper__t6Wl5","icon":"notificationStats_icon__sVy39","badge":"notificationStats_badge__72wCW"};